export enum EDateGroup {
  ByHour = 0,
  ByDay,
  ByWeek,
  ByMonth,
}
